export default __webpack_public_path__ + "static/Preston-Knight-1-350x350-510e2dbe51a15578d4b0661d138582a4.jpg";